"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./getEnvironmentFromHostname.cjs");function n(){return e.getEnvironmentFromHostname()==="development"}exports.isDevelopmentEnvironment=n;
//# sourceMappingURL=isDevelopmentEnvironment.cjs.map
